import React from "react";
import { Reveal } from "../shared/Reveal";

const ITEMS = [
  {
    step: "01", primary: true, badge: "START HERE", name: "Intelligent Energy Platform",
    tag: "The Foundation",
    body: "Eniscope metering + our Central Intelligence Infrastructure reveal and eliminate hidden waste, then manage performance in real time — minute by minute.",
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 12h4l3 8 4-16 3 8h4" /></svg>,
  },
  {
    step: "02", name: "Solar PV", tag: "Generate",
    body: "Generate your own clean electricity — sized to your real, measured demand and verified continuously to keep performing.",
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="4" /><line x1="12" y1="2" x2="12" y2="4" /><line x1="12" y1="20" x2="12" y2="22" /><line x1="2" y1="12" x2="4" y2="12" /><line x1="20" y1="12" x2="22" y2="12" /><line x1="5" y1="5" x2="6.5" y2="6.5" /><line x1="17.5" y1="17.5" x2="19" y2="19" /><line x1="19" y1="5" x2="17.5" y2="6.5" /><line x1="6.5" y1="17.5" x2="5" y2="19" /></svg>,
  },
  {
    step: "03", name: "Battery Storage", tag: "Store & Optimise",
    body: "Store and dispatch intelligently against live demand — maximising self-consumption, resilience and return on every kWh.",
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="7" width="16" height="10" rx="2" /><line x1="22" y1="11" x2="22" y2="13" /><line x1="7" y1="12" x2="9" y2="12" /><line x1="8" y1="11" x2="8" y2="13" /><line x1="12" y1="12" x2="14" y2="12" /></svg>,
  },
];

export default function Products() {
  return (
    <section id="products" className="arcsec pillars">
      <div className="arc" />
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">THE COMPLETE SOLUTION</Reveal>
        <Reveal className="h2" tag="div">Three Products. <span className="g">One Intelligent Order.</span></Reveal>
        <Reveal className="lead" tag="p">It always starts with intelligence. Eliminate waste first — then Solar PV and Battery Storage deliver their full return.</Reveal>
        <div className="prodcards">
          {ITEMS.map((it, i) => (
            <Reveal className="rv" tag="div" key={it.name} style={{ transitionDelay: `${i * 0.08}s` }}>
              <div className={`pcard2 ${it.primary ? "primary" : ""}`} data-testid={`product-${i}`}>
                {it.badge && <span className="badge">{it.badge}</span>}
                <div className="step">{it.step}</div>
                <div className="ic">{it.icon}</div>
                <h3>{it.name}</h3>
                <div className="tagline">{it.tag}</div>
                <p>{it.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
